/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
export { R as ion_ripple_effect } from './ripple-effect-0576252b.js';
import './index-06cd27b1.js';
import './ionic-global-a049bcbf.js';
